export default function getCategoryId({ id, url }) {
  const regexp = /^\d+$/;

  // check for real id instead of ui constructed fake id, real id example: 1234; ui constructed id example: 1_2_3
  if (id && regexp.test(id)) {
    return id;
  }

  // try to parse id from url
  const idInUrlMatch = url.match(/id=(\d+)/);
  if (idInUrlMatch) {
    return idInUrlMatch[1];
  }

  // return ui constructed id in the worst case
  return id;
}
